import Vue from 'vue'
import axios from '../plugins/axios'

Vue.prototype.$http = axios

const getDefaultState = () => {
    return {
        displayMode: 'CARD',
        search: null,
        campaignType: ['CMAJ', 'CADH'],
        archived: false,
        ownCampaign: false
    }
}

const campaignFilter = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setDisplayMode(state, value) {
            state.displayMode = value
        },
        setSearch(state, value) {
            state.search = value
        },
        setCampaignType(state, value) {
            state.campaignType = value
        },
        setArchived(state, value) {
            state.archived = value
        },
        setOwnCampaign(state, value) {
            state.ownCampaign = value
        },
        removeCampaignType(state, index) {
            state.campaignType.splice(index, 1)
        },
        resetState(state) {
            Object.assign(state, getDefaultState())
        }
    }
}

export default campaignFilter